import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

interface ListItemType {
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  primary: string;
  children?: ListItemType[];
  open?: boolean;
  className?: string;
  collapseClassName?: string;
  classNameText?: string;
  classNameTextCollapse?: string;
  classNameButtonCollapse?: string;
  classNameListItem?: string;
}

interface CommonListProps {
  items: ListItemType[];
  className?: string;
  expandLogoClassName?: string;
  collapseBoxClassName?: string;
  childrencomponents?: any;
}

const CommonList: React.FC<CommonListProps> = ({
  items,
  className,
  expandLogoClassName,
  collapseBoxClassName,
  childrencomponents,
}) => {
  return (
    <List className={`${className}`}>
      {items.map((item, index) => (
        <ListItem key={index} disablePadding className={item.classNameListItem}>
          <ListItemButton onClick={item.onClick} className={item.className}>
            <ListItemText
              primary={item.primary}
              className={item.classNameText}
            />
            {item.children && (
              <Box className={`${collapseBoxClassName}`}>
                {item.open ? (
                  <ExpandLess className={`${expandLogoClassName}`} />
                ) : (
                  <ExpandMore className={`${expandLogoClassName}`} />
                )}
              </Box>
            )}
          </ListItemButton>
          {item.children && (
            <Collapse
              in={item.open}
              timeout="auto"
              unmountOnExit
              className={item.collapseClassName}
            >
              <List>
                {item.children.map((child, idx) => (
                  <ListItem key={idx} disablePadding>
                    <ListItemButton
                      className={child.classNameButtonCollapse}
                      onClick={child.onClick}
                    >
                      <ListItemText
                        primary={child.primary}
                        className={child.classNameTextCollapse}
                      />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Collapse>
          )}
        </ListItem>
      ))}
      {childrencomponents}
    </List>
  );
};

export default CommonList;
